import { UserRole } from '@lmc/ts-common'

export const isGroupUser = (
  role: UserRole | string | null | undefined
): boolean => role === UserRole.groupAdmin || role === UserRole.groupManager

// Roles excluded from eMAR/medication write actions (add/edit/stock/
// configuration). Mirrors existing access rules: audit-view is read-only, and
// family and group-level users have no resident/medication access. Used as a
// role-based stand-in for the medication-management capability check.
export const isMedicationRestrictedRole = (
  role: UserRole | string | null | undefined
): boolean =>
  isGroupUser(role) || role === UserRole.auditView || role === UserRole.family
